import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { style: {"--min-height":"40px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.isMultiSelect)
              ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
                  default: _withCtx(() => [
                    (_ctx.selectedSchoolIds.length == 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Select schools"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.selectedSchoolIds.length) + " school" + _toDisplayString(_ctx.selectedSchoolIds.length == 1 ? '' : 's') + " selected", 1))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_ion_title, { key: 1 }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("Your school")
                  ])),
                  _: 1,
                  __: [8]
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_ion_toolbar, { style: {"--min-height":"36px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_searchbar, {
              style: {"padding-bottom":"0","height":"36px"},
              mode: "ios",
              modelValue: _ctx.searchKeyword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKeyword) = $event)),
              placeholder: _ctx.isMultiSelect ? 'Search' : 'Search / Add New',
              onIonFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSearching = true)),
              onIonBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSearching = false)),
              onKeyup: _cache[4] || (_cache[4] = _withKeys((e) => e.target.blur(), ["enter"]))
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        (_ctx.selectedSchoolIds.length > 0)
          ? (_openBlock(), _createBlock(_component_ion_toolbar, {
              key: 0,
              style: {"--min-height":"24px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSchoolIds, (schoolId) => {
                    return (_openBlock(), _createBlock(_component_ion_chip, {
                      class: "small-chip",
                      key: schoolId
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(schoolId.toUpperCase()), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.close,
                          onClick: ($event: any) => (_ctx.selectedSchools[schoolId] = false)
                        }, null, 8, ["icon", "onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSchools(_ctx.schools).slice(0, _ctx.numOfVisibleItems), (school) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: school.id,
                onClick: ($event: any) => (_ctx.isMultiSelect ? undefined : _ctx.closeModal(`[${school.nameShort}] ${school.name}`, school.id)),
                button: !_ctx.isMultiSelect,
                detail: !_ctx.isMultiSelect
              }, {
                default: _withCtx(() => [
                  (_ctx.isMultiSelect)
                    ? (_openBlock(), _createBlock(_component_ion_checkbox, {
                        key: 0,
                        justify: "start",
                        labelPlacement: "end",
                        modelValue: _ctx.selectedSchools[school.id],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.selectedSchools[school.id]) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(school.nameShort), 1),
                              _createElementVNode("p", null, [
                                _createElementVNode("span", null, [
                                  _createTextVNode(_toDisplayString(school.name), 1),
                                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1))
                                ]),
                                _createElementVNode("span", null, _toDisplayString(school.nameChi), 1)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]))
                    : (_openBlock(), _createBlock(_component_ion_label, {
                        key: 1,
                        class: "ion-text-wrap"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, _toDisplayString(school.nameShort), 1),
                          _createElementVNode("p", null, [
                            _createElementVNode("span", null, [
                              _createTextVNode(_toDisplayString(school.name), 1),
                              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))
                            ]),
                            _createElementVNode("span", null, _toDisplayString(school.nameChi), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                ]),
                _: 2
              }, 1032, ["onClick", "button", "detail"]))
            }), 128)),
            _withDirectives(_createVNode(_component_ion_item, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeModal(_ctx.searchKeyword))),
              button: "",
              detail: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.searchKeyword), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.filteredSchools(_ctx.schools).length == 0]
            ]),
            _createVNode(_component_ion_infinite_scroll, {
              onIonInfinite: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadData($event, _ctx.schools))),
              threshold: "100px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_infinite_scroll_content, {
                  "loading-spinner": "bubbles",
                  "loading-text": "Loading..."
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.isMultiSelect && _ctx.selectedSchoolIds.length > 0)
      ? (_openBlock(), _createBlock(_component_ion_footer, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  expand: "block",
                  color: "success",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmMultiSelect()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.checkmark
                    }, null, 8, ["icon"]),
                    _cache[11] || (_cache[11] = _createTextVNode(" Done "))
                  ]),
                  _: 1,
                  __: [11]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}